'use client'

import { SlideshowArrows } from '@fukku/slideshow/components/SlideshowArrows/SlideshowArrows'
import { SlideshowDots } from '@fukku/slideshow/components/SlideshowDots/SlideshowDots'
import { SlideshowItems } from '@fukku/slideshow/components/SlideshowItems/SlideshowItems'
import { SlideshowPreloadedItems } from '@fukku/slideshow/components/SlideshowPreloadedItems/SlideshowPreloadedItems'
import { SlideshowProvider } from '@fukku/slideshow/context/SlideshowProvider'
import type { SlideshowProps } from '@fukku/slideshow/types/Slideshow'
import type { JSX } from 'react'
import { cx } from 'utils/cx'
import styles from './Slideshow.module.scss'

export function Slideshow({
	ariaLabel,
	children,
	className,
	dataTestId,
	initialAnimation,
	onSwipe,
	onAnimationEnd,
	hasDotsIndicator = true,
	hasPreload = false,
	hasLoop = true,
	labels = { previous: 'previous', next: 'next' },
	blockTouchEvents = false,
	defaultActiveItemIndex = 0,
}: Readonly<SlideshowProps>): JSX.Element {
	return (
		<SlideshowProvider
			defaultActiveItemIndex={defaultActiveItemIndex}
			hasPreload={hasPreload}
			hasLoop={hasLoop}
			blockTouchEvents={blockTouchEvents}
			onSwipe={onSwipe}
			onAnimationEnd={onAnimationEnd}
			items={children}
		>
			{/* biome-ignore lint/a11y/useSemanticElements: Prefer <div> over <section> for carousel as it does not contain a heading.*/}
			<div
				role='group'
				aria-roledescription='carousel'
				aria-label={ariaLabel}
				className={cx(className, styles.slideshowWrapper)}
				data-testid={dataTestId}
			>
				<SlideshowPreloadedItems />
				<SlideshowItems initialAnimation={initialAnimation} />
				<SlideshowArrows dataTestId={dataTestId} labels={labels} />
				{hasDotsIndicator && <SlideshowDots>{children}</SlideshowDots>}
			</div>
		</SlideshowProvider>
	)
}
